import { Box, Button, Section, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { SettingsFormFields } from './SettingsFormFields'
import { WarningBanner } from './WarningBanner'
import { useFinancialWorkspaceSettings } from './useFinancialWorkspaceSettings'

const FinancialWorkspaceSettings = () => {
  const {
    setFieldValue,
    dirty,
    handleSubmit,
    loading,
    showBanner,
    defaultConceptIdsToAdd,
    defaultConceptIdsToSubtract,
    setExpensesConceptDetected,
  } = useFinancialWorkspaceSettings()

  return (
    <ResponsivePage.Body variant="wide" showHeader={false}>
      <Section.Form
        disabled={loading}
        illustration="money"
        submitLabel={i18n.t('common.submit')}
        title={i18n.t('finance.financial_workspace.settings.labor_cost.title')}
        description={i18n.t('finance.financial_workspace.settings.labor_cost.description')}
      >
        <Text.Normal weight="semibold" size="300">
          {i18n.t('finance.financial_workspace.settings.labor_cost.form_title')}
        </Text.Normal>
        <SettingsFormFields
          setFieldValue={setFieldValue}
          defaultConceptIdsToAdd={defaultConceptIdsToAdd}
          defaultConceptIdsToSubtract={defaultConceptIdsToSubtract}
          setExpensesConceptDetected={setExpensesConceptDetected}
        />
        {showBanner && <WarningBanner />}

        <Box flexDirection="row" gap="s8" justifyContent="flexEnd">
          {dirty && (
            <Button type="primary" disabled={loading} onClick={() => handleSubmit()}>
              {i18n.t('common.submit')}
            </Button>
          )}
        </Box>
      </Section.Form>
    </ResponsivePage.Body>
  )
}

export default FinancialWorkspaceSettings
